import { EtablissementFichierType } from '@common/services/etablissement-fichier';

export const ETABLISSEMENT_FICHIER_TYPE_TEXTS: Record<EtablissementFichierType, string> = {
  [EtablissementFichierType.DECLARATION]: 'Déclaration',
  [EtablissementFichierType.ATTESTATION]: 'Attestation',
  [EtablissementFichierType.ALERTES]: 'Fichier d\'alertes',
};